import Vue from 'vue';
import Vuex from 'vuex';

import user from './user';
import chat from './chat';
import articleAutocomplete from './articleAutocomplete';
import transaction from './transaction/transaction.store';
import chatWarning from './chatWarning/chatWarning.store';
import analyticsConsent from './analyticsConsent/analyticsConsent.store';
import articleMetrics from './articleMetrics/articleMetrics.store';
import channelLoading from './channel-loading.store';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    user,
    chat,
    articleAutocomplete,
    transaction,
    chatWarning,
    analyticsConsent,
    articleMetrics,
    channelLoading,
  },
  strict: process.env.NODE_ENV !== 'production',
});
